import { render, staticRenderFns } from "./airspace.vue?vue&type=template&id=3dbd12bc&scoped=true&"
import script from "./airspace.vue?vue&type=script&lang=js&"
export * from "./airspace.vue?vue&type=script&lang=js&"
import style0 from "./airspace.vue?vue&type=style&index=0&id=3dbd12bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd12bc",
  null
  
)

export default component.exports